<main class="home-full">
  <nibtravel-travel-alert
    *featureToggle="Features.TravelAlertId"
    class="alert-travel alert-travel--home"
  >
  </nibtravel-travel-alert>
  <div class="home-container">
    <ng-container *featureToggle="Features.HeroId">
      <nibtravel-snippet
        *contentful="ContentTypes.Hero; zone: ZoneId.Home; let data"
        [entry]="data"
      >
      </nibtravel-snippet>
    </ng-container>
    <nibtravel-qqc *featureToggle="Features.QqcShellId"></nibtravel-qqc>
  </div>
  <nibtravel-cookies-alert
    *featureToggle="Features.CookiesAlertId"
  ></nibtravel-cookies-alert>
</main>
